module.exports = __webpack_public_path__ + "img/gray.02865c67.svg";